import Vue from 'vue';
import common  from '../../common';
import { LOGIN_WITH_BOTH, LOGIN_ONLY_WITH_QQ, LOGIN_ONLY_WITH_WX } from './constant';

// 是否端游
const isClientGame = () => Vue.prototype?.$actInfo?.game_type === 1;
// 强制登录类型
const handlerImposeLoginType = ({ imposeLoginType = LOGIN_WITH_BOTH, needWXLogin = false } = {})  => {
  const getimposeLoginType = () => {
    if (isClientGame()) {
      if (needWXLogin) {
        if (common.platform.isWX || common.platform.isSafari) {
          return LOGIN_WITH_BOTH;
        }
        return LOGIN_ONLY_WITH_QQ;
      }
      return LOGIN_ONLY_WITH_QQ;
    }
    if (common.platform.isWX || common.platform.isSafari) {
      return imposeLoginType;
    }
    return LOGIN_ONLY_WITH_QQ;
  };
  const type = getimposeLoginType();
  // 带红包标识链接处理逻辑，微信内仅限QQ登录
  const isHasRedPacket = Boolean(common.tool.getQueryParams('C_IS_RED_PACKET'));
  if (isHasRedPacket && common.platform.isWX) {
    if (type === LOGIN_WITH_BOTH) {
      return LOGIN_ONLY_WITH_QQ;
    }
    if (type === LOGIN_ONLY_WITH_WX) {
      return LOGIN_ONLY_WITH_WX;
    }
    if (type === LOGIN_ONLY_WITH_QQ) {
      return LOGIN_ONLY_WITH_QQ;
    }
  }
  return type;
};

export default handlerImposeLoginType;
